<template>
  <div>
    <div class="card">
      <div class="card-header d-flex justify-content-between align-items-center">
        <span>Nota de Reembolso da Fonte Pagadora</span>
        <div>
          <b-button v-if="!refundNote.refund.paid" variant="warning" style="margin-right: 5px" size="sm" @click="expenseNotePaid">
            <i class="fa fa-dollar"></i>&nbsp;Pagou?
          </b-button>
          <b-button v-else variant="success" disabled style="margin-right: 5px" size="sm">
            <i class="fa fa-check"></i>&nbsp;Pago
          </b-button>
          <b-button variant="primary" size="sm" @click="print()">
            <i class="fa fa-print"></i>&nbsp;Imprimir
          </b-button>
        </div>
      </div>
      <div class="card-body">
        <div id="printme" class="col-sm-12">
          <div class="row">
            <div class="col-sm-12">
              <img src="/assets/img/logo.jpg" alt="" width="200px">
              <h4 class="text-center border" style="background-color: #f3f3f2; padding: 10px 0;margin-bottom:0;border-bottom:0!important;flex:1">
                <div class="d-flex">
                  <span style="flex: 1;">Nota de Reembolso da Fonte Pagadora</span>
                  <span style="padding-right: 10px;">{{ refundNote.refund.code }}</span>
                </div>
              </h4>
              <table class="table border lead" style="padding: 10px 0">
                <tbody v-if="refundNote.refund.employee">
                  <tr>
                    <th style="width:75px">Funcionário:</th>
                    <td>{{ refundNote.refund.employee }}</td>
                  </tr>
                  <tr>
                    <th style="width:75px" v-if="refundNote.refund.cnpj">CNPJ:</th>
                    <th v-else>CPF:</th>
                    <td>
                      <span v-if="refundNote.refund.cnpj">{{ refundNote.refund.cnpj | VMask('##.###.###/####-##') }}</span>
                      <span v-else>
                        <span v-if="refundNote.refund.cpf">{{ refundNote.refund.cpf | VMask('###.###.###-##') }}</span>
                        <span v-else>---</span>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <th style="width:75px">Vencimento:</th>
                    <td v-if="refundNote.refund.expiration_date">{{ refundNote.refund.expiration_date | formatDate }}</td>
                    <td v-else>---</td>
                  </tr>
                </tbody>
              </table>
              <table class="table table-responsive-sm table-bordered table-striped lead">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Data</th>
                    <th>Tipo</th>
                    <th>Descrição</th>
                    <th class="text-right">Valor</th>
                  </tr>
                </thead>
                <tbody v-if="refundNote">
                  <tr v-for="(refund, itemIdx) in refundNote.data" :key="refund.items[0].pk">
                    <td>{{ itemIdx + 1 }}</td>
                    <td>{{ refund.items[0].payment_date | formatDate }}</td>
                    <td>{{ refund.items[0].type_expense.text }}</td>
                    <td>{{ refund.items[0].description }}</td>
                    <td>R$ <span class="pull-right">{{ refund.items[0].value | formatPrice }}</span></td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th class="text-right" colspan="4">Valor Total</th>
                    <th style="width:150px">R$ <span class="pull-right">{{ refundNote.refund.total | formatPrice }}</span></th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <div class="border lead" style="padding:15px 0 0 10px;line-height:.5em;">
            <p>Dados para depósito</p>
            <p>Pinheiro e Sandi Sociedade de Advogados</p>
            <p>CNPJ: 30.589.909/0001-98</p>
            <p>Banco Itaú 341</p>
            <p>Agência 8474</p>
            <p>Conta 19.687-3</p>
          </div>
          <div class="text-center lead" style="padding-top:20px;line-height:1em">
            <p>Rua Joaquim Floriano, 72, conj. 175 - Itaim Bibi - São Paulo - SP - Brasil F: 11 2528-1044</p>
            <p>www.pgsa.com.br</p>
          </div>
          <div class="page-break">
            <ul class="list-group" v-if="refundNote">
              <div v-for="refund in refundNote.data" :key="refund.items[0].pk">
                <div class="div-break">
                  <li class="list-group-item">
                    <p>{{ refund.items[0].description }}</p>
                    <img :src="refund.items[0].doc_jpg.url" v-if="refund.items[0].doc_jpg && refund.items[0].doc_jpg.url" width="50%" height="auto">
                    <p class="lead" v-else>Sem anexo.</p>
                  </li>
                </div>
                <br class="page-break">
              </div>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import GenericForm from '../../components/GenericForm';
import axios from 'axios';

export default {
  components: {
    GenericForm,
  },
  data() {
    return {
      isVisible: false,
      refundNote: {
        refund: {}
      },
    };
  },
  mounted() {
    axios.get('/financial/expense-note/' + this.$route.params.pk)
      .then(res => {
        this.refundNote = res.data;
      });
  },
  methods: {
    expenseNotePaid() {
      // Pergunta se o Funcionário pagou a NR.
      this.$swal.fire({
        title: 'Funcionário pagou?',
        text: 'O Funcionário pagou a Nota de Reembolso?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        focusCancel: true
      }).then((result) => {
        if (result.value) {
          // Criar NR
          axios.post('/financial/expense-note/' + this.$route.params.pk + '/paid/')
            .then(res => {
              this.refundNote.refund = res.data.data;
            })
        }
      })
    },
    print() {
      window.open('/app/financials/repayment/expense-note/' + this.$route.params.pk + '/print');
    },
  }
}

</script>
